var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.fixed)?_c('div',{staticClass:"head-ghost"}):_vm._e(),_c('div',{staticClass:"head",class:{
    'has-actions': _vm.hasActions, 
    'is-fixed': _vm.fixed,
	'is-scrolled': _vm.isScrolled
}},[(_vm.stickyFields.length)?_c('div',{staticClass:"head-inner is-sticky inner",style:({
			gridTemplateColumns: _vm.gridStickyFinal
		})},[_c('div'),_vm._l((_vm.stickyFields),function(field){return _c('app-view-sheet-column',{key:field.id,attrs:{"field":field,"filter":_vm.filter}})})],2):_vm._e(),_c('div',{staticClass:"head-inner inner",style:({
			gridTemplateColumns: _vm.gridFinal,
			marginLeft: _vm.marginLeft
		})},[_c('div'),_vm._l((_vm.fields),function(field){return _c('app-view-sheet-column',{key:field.id,attrs:{"field":field,"filter":_vm.filter}})}),(_vm.hasActions)?_c('core-list-column-actions',{staticClass:"head-actions",attrs:{"horizontal":true}}):_vm._e(),_c('div')],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }